import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

const InvalidWorkspacePage = (): JSX.Element => <p>Invalid workspace.</p>;

export const Route = createFileRoute("/invalid-workspace/")({
	component: InvalidWorkspacePage,
});
